import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbJira: BowlBlock = withIntegration(options.slug.llmKbJira, [
  {
    name: 'accessToken',
    type: 'withText',
    required: true,
  },
  {
    name: 'url',
    type: 'withText',
    required: true,
  },
  {
    name: 'userEmail',
    type: 'withText',
    required: true,
  },
  {
    name: 'projects',
    type: 'text',
    hasMany: true,
    required: true,
  },
  {
    name: 'boards',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'issues',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'jqlFilter',
    type: 'withText',
    admin: {
      description: 'jira_JQL_filter',
    },
  },
]);
